<template>
    <div class="login-content">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-5 mx-auto">
                    <div class="login-wrap">
                        <div class="login-header">
                            <h3>Entrez OTP</h3>
                            <p>Veuillez entrer le OTP envoyé à votre adresse e-mail</p>
                        </div>

                        <!-- Formulaire OTP -->
                        <b-form @submit.prevent="verifierOTP">
                            <div class="form-group group-img">
                                <div class="group-img">
                                    <i class="feather-mail"></i>
                                    <b-form-input type="text" class="form-control" placeholder="Entrez OTP" v-model="otp" />
                                </div>
                            </div>
                            <b-button variant="primary w-100 login-btn" type="submit">Vérifier OTP</b-button>
                        </b-form>
                        <!-- /Formulaire OTP -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { verifyOTP } from '@/services/authService';
import Swal from 'sweetalert2';
import router from '@/router/index';

export default {
    data() {
        return {
           
                email: '',
                otp: '',
        
        };
    },
    created() {
        // Récupérer l'email du stockage local et le stocker dans user.email
        this.email = localStorage.getItem('userEmail');
    },
    methods: {
        async verifierOTP() {
            try {
                const reponse = await verifyOTP(this.email, this.otp);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: reponse.message,
                    })
                    .then(() => {
                        this.$router.push('/dashboard');
          });
            } catch (erreur) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: erreur.message, 
                });
            }
        },
    },
};
</script>
